import styled from "styled-components";

export const ModalContainer = styled.div`
.overlay {
    background-color: rgba(0, 0, 0, 0.55);
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    position: fixed;
    display: none;
    z-index: 55;
  }
  
  .overlay.show {
    display: block;
  }
  
  .Modal {
    position: fixed;
    top: 0;
    right: -50vw;
    z-index: 1200;
    height: 100vh;
    width: 50vw;
    background-color: #fff;
    right: -50vw;
    transition: all 0.2s ease-in-out;
  }
  
  .Modal.show {
    display: block;
    right: 0;
    transition: all 0.2s ease-in-out;
  }

  .modal-body-scroll {
    max-height: calc(100vh - 82px);
    min-height: calc(100vh - 82px);
    padding-bottom: 150px !important;
    overflow-y: auto;
    word-wrap: break-word;
    padding: 15px;
  }
  
  .display-block {
    display: block;
  }
  
  .display-none {
    display: none;
  }

  .modal-header {
    text-align: right;
    margin-bottom: 15px;
    padding: 15px;
  }

  .close-dialog-btn {
    background-color: #fff;
    border: none;
    font-size: 24px;
    display: inline-block;
    margin-top: -10px;
  }

  .service-config.container,
  .container.topic {
    border: 1px solid #b1b1b1;
    border-radius: 4px;
  }
`